var menuItems = document.querySelectorAll('.menu .nav-main-item');

if (window.innerWidth > 960) {
    menuItems.forEach(function (item) {
        item.addEventListener('mouseover', function () {
            if (!document.querySelector('header').classList.contains('header--fixed')) {
                document.querySelector('header').classList.add('header--full');
            };
        });

        item.addEventListener('mouseout', function () {
            document.querySelector('header').classList.remove('header--full');
        });
    });
}

else {
    document.querySelector('.nav-main_icon').addEventListener('click', function () {
        if (document.querySelector('header').classList.contains('header--full')) {
            document.querySelector('header').classList.remove('header--full');
        }
        
        else {
            document.querySelector('header').classList.add('header--full');
        }
    });
        
    menuItems.forEach(function (item) {
        item.addEventListener('click', function () {
            let activeItem = document.querySelector('.nav-main-item.active');
            this.classList.toggle('active');
            document.querySelector('#nav-main .header-profil__content').classList.remove('header-profil__content--show');

            if (activeItem) {
                activeItem.classList.remove('active');
            }
        });
    });
}